import AniversarioLista from './AniversarioLista';
import ExperienciaLista from './ExperienciaLista';
import FeriasVencendoLista from './FeriasVencendoLista';
import Lista from './Lista';

export const VinculoEmpregaticioAniversarioLista = AniversarioLista;
export const VinculoEmpregaticioLista = Lista;
export const VinculoEmpregaticioExperienciaLista = ExperienciaLista;
export const VinculoEmpregaticioFeriasVencendoLista = FeriasVencendoLista;
